import { PropType } from 'vue';
import { Vue, Options } from 'vue-class-component';
import {
  EPDeviceDTO,
  GateDTO,
} from '@/../client-generator/generated-clients/plants';
import { getDeviceIconFromType } from '../../../../../core/utils/EntrancePlant/entrance-plant.utils';

@Options({
  name: 'DeviceItem',
  props: {
    device: {
      type: Object as PropType<EPDeviceDTO>,
      required: true,
    },
  },
})
export default class DeviceItem extends Vue {
  device!: EPDeviceDTO;
  gate!: GateDTO;
  getDeviceIconFromType = getDeviceIconFromType;

  getDeviceName() {
    switch (this.device.type) {
      case 0:
        return this.$t('AppResourceEP.NewPeDevice');
      case 1:
        return this.$t('AppResourceEP.KeyPad');
      case 2:
        return this.$t('AppResourceEP.SmartReader');
      default:
        'UNKNOWN';
    }
  }
}
